/**
 * Filtre une liste de formations { id, label } par requête texte,
 * avec priorité optionnelle (ex. instruments déjà présents dans le corpus).
 */

function normalize(str) {
  return String(str || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

/**
 * @param {{ id: string, label: string }[]} masterList
 * @param {string} query
 * @param {string[]} [prioritizedIds] - ids affichés en premier (ordre conservé), puis le reste par label
 * @returns {{ id: string, label: string }[]}
 */
export function filterFormationsByQuery(masterList, query, prioritizedIds = []) {
  const list = Array.isArray(masterList) ? masterList : []
  const q = normalize(query).trim()
  const priOrder = Array.isArray(prioritizedIds) ? prioritizedIds : []

  let filtered = list
  if (q) {
    filtered = list.filter((f) => {
      const label = normalize(f.label)
      const idSpaced = normalize(String(f.id).replace(/_/g, ' '))
      const idCompact = normalize(String(f.id).replace(/_/g, ''))
      return label.includes(q) || idSpaced.includes(q) || idCompact.includes(q.replace(/\s/g, ''))
    })
  }

  const seen = new Set()
  const out = []
  for (const id of priOrder) {
    const f = filtered.find((x) => x.id === id)
    if (f && !seen.has(f.id)) {
      out.push(f)
      seen.add(f.id)
    }
  }
  const rest = filtered
    .filter((f) => !seen.has(f.id))
    .sort((a, b) => a.label.localeCompare(b.label, 'fr', { sensitivity: 'base' }))
  return [...out, ...rest]
}
